import { SetActiveTab } from "../../../../../../shared/scripts/tab-utilities";
import { ISiteInfo } from "../../../scripts/data-completeness.page";
import { OutcomesDialog } from "../scripts/outcomes.dialog";
import { OutcomeEvent } from "../scripts/outcomes.entities";
import { OutcomesLookup } from "../scripts/outcomes.lookup";
import { OutcomesSummarySeries } from "./outcomes-summary.entities";


var Highcharts = require('highcharts/highcharts');


export class OutcomesSummaryView {

    outcomeSummaryChart: any;
    siteSummaryChart: any;
    outcomeReasonsChart: any;
    siteReasonsChart: any;

    selectedGrouping: string; //outcome, site
    selectedData: string; //status, reasons

    constructor() {
        this.selectedGrouping = "outcome";
        this.selectedData = "status";
    }

    UpdateData(outcomeSeries: OutcomesSummarySeries[], siteSeries: OutcomesSummarySeries[]): void {

        //console.log(outcomeSeries);
        //console.log(siteSeries);

        this.updateChart('outcomes-byoutcome-summary-status-chart', outcomeSeries, [1, 3, 4, 2, 5], "Outcomes");
        this.updateChart('outcomes-bysite-summary-status-chart', siteSeries, [1, 3, 4, 2, 5], "Sites");
        //this.updateChart('outcomes-byoutcome-summary-reasons-chart', outcomeSeries, OutcomesLookup.GetReasonMissingOrderingArray(), "Outcomes");
        //this.updateChart('outcomes-bysite-summary-reasons-chart', siteSeries, OutcomesLookup.GetReasonMissingOrderingArray(), "Sites");
    }

    private updateChart(chartId: string, data: OutcomesSummarySeries[], outcomeStatusIds: number[], axisLabel: string): void {

        let series: any[] = [];
        let categories: string[] = [];
        let outcomes: OutcomeEvent[] = [];

        outcomeStatusIds.forEach((statusId: number) => {

            let seriesData: any[] = new Array<any>(data.length).fill(0);
            for (let i = 0; i < data.length; ++i) {

                if (!categories.includes(data[i].name)) { categories.push(data[i].name); }
                if (data[i].outcomes.has(statusId)) {
                    seriesData[i] = { y: data[i].outcomes.get(statusId).length, outcomes: data[i].outcomes.get(statusId) };
                }
            }

            series.push({ name: OutcomesLookup.GetOutcomeStatus(statusId), data: seriesData, colorIndex: OutcomesLookup.GetColorIndex(statusId) });
        });

        this.initializeBarChart(chartId, axisLabel, categories, series);
    }

    private initializeBarChart(chartId: string, axisLabel: string, categories: string[], data: any[]): any {

        //console.log(chartId, axisLabel, categories, data);
        //console.log(categories.length, (40 * categories.length));
        //console.log(data);

        let chart: any = Highcharts.chart(chartId, {
            chart: {
                type: 'bar',
                styledMode: true,
                height: 100 + (45 * categories.length)
            },
            credits: { enabled: false },
            title: { text: null },
            xAxis: {
                type: 'category',
                categories: categories,
                min: 0,
                max: categories.length - 1,
                title: { text: axisLabel },
                tickInterval: 1,
                tickLength: 0,
            },
            yAxis: {
                min: 0,
                endOnTick: false, // helps with cropping data labels
                maxPadding: 0.2, // larger value has more space for data labels (default is 0.05)
                reversedStacks: false,
                title: { text: 'Outcome Count' },
                labels: {
                    formatter: function () {
                        return Highcharts.numberFormat(this.value, 0, '.', ',');
                    }
                },
                stackLabels: {
                    enabled: true,
                    formatter: function () {
                        return Highcharts.numberFormat(this.total, 0, '.', ',');
                    },
                    inside: false, //label issues
                    verticalAlign: 'middle',
                }
            },
            legend: {
                align: 'center',
                verticalAlign: 'top',
            },
            plotOptions: {
                series: {
                    stacking: 'normal',
                    point: {
                        events: {
                            click: function () {
                                OutcomesDialog.ShowDialog(this.options.outcomes);
                            }
                        }
                    },
                },
                bar: {
                    pointWidth: 25,
                    pointPadding: 0.1,
                    //groupPadding: 0.2,
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        formatter: function () {
                            if (this.y == 0) return null;
                            else {
                                let label: string = Highcharts.numberFormat(this.y, 0, '.', ',');
                                if (this.point.shapeArgs.height <= (label.length * 10)) return null;
                                else return label;
                            }
                        },
                        verticalAlign: 'middle',
                        y: 2
                    },
                },
            },
            series: data
        });

        return chart;
    }


    SetView(newView: string): void {

        if (!newView.startsWith("outcomes-summary")) { return; }
        else if (newView != "outcomes-summary") { //new within-summary view
            if (newView.includes("byoutcome")) { this.selectedGrouping = "outcome"; }
            else if (newView.includes("bysite")) { this.selectedGrouping = "site"; }

            if (newView.includes("bystatus")) { this.selectedData = "status"; }
            //else if (newView.includes("byreason")) { this.selectedData = "reason"; }
        }

        if (this.selectedGrouping == "outcome" && this.selectedData == "status") { SetActiveTab("outcomes-summary-tabs", "content-summary-outcomes-byoutcome-status"); }
        else if (this.selectedGrouping == "site" && this.selectedData == "status") { SetActiveTab("outcomes-summary-tabs", "content-summary-outcomes-bysite-status"); }
        //else if (this.selectedGrouping == "outcome" && this.selectedData == "reason") { SetActiveTab("outcomes-summary-tabs", "content-summary-outcomes-byoutcome-reasons"); }
        //else if (this.selectedGrouping == "site" && this.selectedData == "reason") { SetActiveTab("outcomes-summary-tabs", "content-summary-outcomes-bysite-reasons"); }

    }

}

